import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import remoteIcon from "../../../../../assets/design-revamp-company/company-detail-headers/remote-icon.svg";
import { useTranslation } from "react-i18next";
import { getRemoteList } from "../../../../../apis/Business/RemoteApi";
import handleToFixedNum from "../../components/HeaderBox/handleToFixedNum";
import formatDate from "../../components/HeaderBox/formatDate";

const RemoteIcon = () => (
  <img src={remoteIcon} alt="Remote Icon" width={76} height={76} />
);

const RemoteHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  businessId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalObjRemote, setTotalObjRemote] = useState([]);
  const [systemBoundaryRemote, setSystemBoundaryRemote] = useState("");
  useEffect(() => {
    getRemoteList({
      businessId: businessId,
      setTotalObj: setTotalObjRemote,
      setSystemBoundaryCommute: setSystemBoundaryRemote,
    });
  }, [businessId]);

  return (
    <CategoryComponent
      show={show}
      className={`remote-category ${className || ""}`}
      leftBoxProps={{
        icon: <RemoteIcon />,
        title: t("REMOTE_WORKING"),
        description: t("REMOTE_WORKING_INTRO"),
        scopes: [{ scope: t("REMOTE_SCOPE"), filled: true }],
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_CATEGORY"),
            items: [
              {
                subtitle: `${t("EMISSIONS")} (tCO₂e)`,
                subitems: [
                  {
                    value: handleToFixedNum(
                      totalObjRemote,
                      totalObjRemote?.total_emissions
                    ),
                  },
                ],
              },
            ],
          },
        ],
        lastUpdated: totalObjRemote?.updated_at
          ? formatDate(totalObjRemote?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      systemBoundaryProps={{
        systemBoundary: systemBoundaryRemote,
        setSystemBoundary: setSystemBoundaryRemote,
        businessId: businessId,
        totalObjCategory: totalObjRemote.category_name,
      }}
      {...props}
    />
  );
};

export default RemoteHeader;
